<template>
  <div>
    <PageHeader :title="title" :items="items"/>

    <catalog-filter
        @marketplace="setMarketplaceQuery"
    />
    <div class="card">
      <div class="card-body">
        <b-row class="justify-content-between">
          <b-col sm="6">
            <PerPageSelector v-model="query.perPage"
                             :available-per-page-options="availablePerPageOptions"
            ></PerPageSelector>
          </b-col>
          <b-col sm="3">
            <DataTableSearch v-model="query.filter" :place-holder="$t('pages.catalog.search')"></DataTableSearch>
          </b-col>
        </b-row>

        <!-- Table data -->
        <div>
          <catalog-list
              ref="catalogList"
              :catalog="catalog"
              :query="query"
              :fetchFunction="getCatalog"
          />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CatalogList from "./Components/CatalogList";
import queryBuilder from "../../mixins/queryBuilder";
import CatalogService from "../../Services/Api/CatalogService";
import PerPageSelector from "../../components/PerPageSelector";
import DataTableSearch from "../../components/DataTableSearch";
import CatalogFilter from "./Components/CatalogFilter";

export default {
  name: "Index",
  page() {
    return {
      title: this.$t('pages.catalog.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  components: {
    CatalogFilter,
    PerPageSelector,
    CatalogList,
    DataTableSearch
  },
  mixins: [
    queryBuilder
  ],
  data() {
    return {
      items: [
        {
          text: this.$t('pages.catalog.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.catalog.items.second'),
          active: true,
        },
      ],
      title: this.$t('pages.catalog.title'),
      catalog: {},
      meta: null,
    }
  },
  methods: {
    async getCatalog(params = this.query) {
      this.query = {...this.query, ...params}
      const query = this.buildQuery()
      const {data: catalog} = await CatalogService.all({query})
      this.catalog = catalog
    },
    setMarketplaceQuery(e) {
      this.query.marketplace = e.map(item => item.marketplace_id).join(',')
      this.$refs.catalogList.refreshTable()
    }
  },
}
</script>

<style scoped>

</style>